import { m as motion } from 'framer-motion';
import { Inline, Text, vars } from '@etg/wings';
import { CheckCircle } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import { CABIN_UPGRADE } from '../../../products';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const perkWrapperStyles = css`
  margin-top: 16px;
  overflow: hidden;
`;
const perkTextWrapperStyles = css`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
const perkTextStyles = css`
  flex: 1;
`;
const CabinUpgradePerks = _ref => {
  let {
    ariaLabel,
    availablePerks,
    segmentKey
  } = _ref;
  return /*#__PURE__*/_jsx(motion.div, {
    animate: "open",
    "aria-label": ariaLabel,
    className: perkWrapperStyles,
    initial: "collapsed",
    role: "list",
    transition: {
      duration: 0.4,
      ease: [0.25, 0.1, 0.25, 1]
    },
    variants: {
      open: {
        opacity: 1,
        height: 'auto'
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    },
    children: availablePerks.map((perk, perkIndex) => /*#__PURE__*/_jsxs(Inline, {
      className: perkTextWrapperStyles,
      "data-testid": `${CABIN_UPGRADE.name}-${segmentKey}-perk-${perkIndex}`,
      role: "listitem",
      spacing: 16,
      children: [/*#__PURE__*/_jsx(CheckCircle, {
        "aria-hidden": "true",
        color: vars.colors.signal.positive.foreground,
        size: 16,
        weight: "fill"
      }), /*#__PURE__*/_jsx(Text, {
        className: perkTextStyles,
        children: perk
      })]
    }, `${segmentKey}-perk-${perkIndex}`))
  }, `${segmentKey}-motion`);
};
export default CabinUpgradePerks;
//# sourceMappingURL=CabinUpgradePerks.js.map